module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row home"
  }, [_c('Modal', {
    attrs: {
      "visible": _vm.modalVisible
    },
    on: {
      "hide": function($event) {
        _vm.modalVisible = false
      }
    }
  }, [_c('div', {
    staticClass: "contact-card"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('p', {
    staticClass: "message"
  }, [_vm._v("Shoot me an email!")]), _c('input', {
    attrs: {
      "value": "mccallalexander96@gmail.com"
    }
  })]), _c('p', {
    staticClass: "message"
  }, [_vm._v("...or contact me here:")]), _c('div', {
    staticClass: "social-links"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/mccallalexander/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })]), _c('a', {
    attrs: {
      "href": "https://github.com/mccallofthewild",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })]), _c('a', {
    attrs: {
      "href": "https://twitter.com/mccallthetall",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x"
  })]), _c('a', {
    attrs: {
      "href": "https://www.linkedin.com/in/mccall-alexander-b245347b/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin fa-2x"
  })])])])]), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row header-row"
  }, [_c('div', {
    staticClass: "col-xs-12 header-col"
  }, [_c('header', [_c('h1', [_vm._v("McCall Alexander")]), _c('h2', [_vm._v("Web Development & Design")]), _c('address', [_vm._v("Boise, Idaho")]), _c('div', {
    staticClass: "cta-container"
  }, [_c('button', {
    staticClass: "btn-cta inline",
    on: {
      "click": _vm.showModal
    }
  }, [_c('div', {
    staticClass: "circle-mark"
  }), _vm._v("Contact me!")]), _c('span', {
    staticClass: "or-text inline"
  }, [_vm._v("...or check out my")]), _c('router-link', {
    staticClass: "btn-cta inline",
    attrs: {
      "tag": "button",
      "to": {
        name: 'portfolio'
      }
    }
  }, [_c('div', {
    staticClass: "circle-mark"
  }), _vm._v("Portfolio")])], 1), (false) ? _c('nav', [_vm._m(0)]) : _vm._e()])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/mccallalexander/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram fa-2x"
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/mccallofthewild",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])]), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/mccallthetall",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter fa-2x"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-295c40c0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 373
// module chunks = 1